// Hazard Fee Computation
async function getCart() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error('Failed to fetch cart data');
    }
    return await response.json();
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function getProduct(handle) {
  try {
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) {
      throw new Error(`Failed to fetch product data for handle: ${handle}`);
    }
    return await response.json();
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function checkConditions(cart) {
  let multiplier = 0;

  for (const item of cart.items) {
    const product = await getProduct(item.handle);
    if (product.tags.includes('Hazmat fee')) {
      multiplier += item.quantity;
    }
  }

  console.log(multiplier);
  return multiplier;
}

async function hazardUpdate(qty) {
  try {
    const updates = {
      50662792495378: qty,
    };

    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    });

    if (!response.ok) {
      throw new Error('Failed to update cart');
    }

    const updatedCart = await response.json();
    const cart = await getCart();
    const hazardProd = updatedCart.items.find(item => item.id == 50662792495378);

    const hazardTitle = document.querySelector('.hazmat-title span');
    const hazardFeeElement = document.querySelector('.hazmat-fee .money');
    const hazardContainer = document.querySelector('.hazmat-fee');
    const cartSubtotalElement = document.querySelector('.cart-subtotal .money');
    const cartTitleTotalElement = document.querySelector('.cart-title-total .money');

    if (hazardProd) {
      const hazardPrice = (hazardProd.final_line_price / 100.0).toFixed(2);
      if (hazardFeeElement) hazardFeeElement.innerHTML = `$${hazardPrice}`;
      if (hazardTitle) hazardTitle.innerHTML = ` * ${qty}`;
      if (hazardContainer) hazardContainer.style.display = 'flex';
    } else {
      if (hazardFeeElement) hazardFeeElement.innerHTML = '$0.00';
      if (hazardContainer) hazardContainer.style.display = 'none';
    }

    if (cartSubtotalElement) cartSubtotalElement.innerHTML = window.Shopify.formatMoney(cart.total_price);
    if (cartTitleTotalElement) cartTitleTotalElement.innerHTML = window.Shopify.formatMoney(cart.total_price);

  } catch (error) {
    console.error('Error:', error);
  }
}

async function hazardComputation() {
  try {
    const checkoutBtn = document.querySelectorAll('button[name="checkout"]');
    checkoutBtn.forEach(btn => {
      btn.disabled = true;
    });

    const hazardLoaderEl = document.querySelector('.hazmat-fee .money');
    if (hazardLoaderEl) hazardLoaderEl.innerHTML = '<div class="cc-loader"></div>';

    const cart = await getCart();
    const multiplier = await checkConditions(cart);
    await hazardUpdate(multiplier);

    checkoutBtn.forEach(btn => {
      btn.disabled = false;
    });
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
}